Vue.component('hotels-map', {
    template: '#vue-hotels-map',
    data: function () {
        return {
        }
    },
    created: function () {
        const self = this;

        serverBus.$emit('loading_start');

        setCanonicalTag('https://' + location.host + '/szukaj-na-mapie-hoteli-pensjonatow-apartamentow');

        let title = 'Szukaj na mapie hoteli';
        let description = 'Szukaj na mapie hoteli';
        let keywords = mainMetaKeywordsStatic + '';

        setPageTitle(title + mainMetaTitleStatic);
        setMeta("description", description + ' - ' + getMeta("description"));
        setMeta("keywords", keywords);
    },
    mounted: function () {
        const self = this;

        loadScript('/js/leaflet.js', () => {
            self.loadMap();
        });
    },
    methods: {
        loadMap: function () {
            console.log('Load Map...');

            L.Icon.Default.imagePath = 'img/leaflet/';

            let map = L.map('map').setView([52.114503, 19.423561], 6);

            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            }).addTo(map);

            $.post("/back/HotelsMap.php", { action: 'list' }, function (result, textStatus) {

                for (let i = 0; i < result.length; i++) {                                        
                    L.marker([result[i]['x'], result[i]['y']]).addTo(map).bindPopup('<p>' + result[i]['name'] + '</br></br><a href="' + result[i]['url'] + '"><button class="btn btn-block btn-primary">Zobacz</button></a></p>');
                }

                serverBus.$emit('loading_end');
            }, "json");
        }
    }
});
